import { html, nothing, TemplateResult } from 'lit';

export interface FormFieldOptions {
  id: string;
  label: string;
  control: TemplateResult;
  hint?: TemplateResult | string;
  error?: string;
}

export function renderFormField({ id, label, control, hint, error }: FormFieldOptions): TemplateResult {
  return html`
    <div class="field">
      <label for=${id}>${label}</label>
      ${control}
      ${hint
        ? html`
            <p class="hint">${hint}</p>
          `
        : nothing}
      ${error !== undefined
        ? html`
            <div id="${id}-error" class="field-error" role="alert">${error}</div>
          `
        : nothing}
    </div>
  `;
}
